import { useEffect, useState } from "react";
import { http, CATEGORIES, waLink } from "@/lib/shop";
import { ProductCard } from "./ProductCard";
import { Skeleton } from "@/components/ui/skeleton";

export const PhonesForSale = () => {
  const [products, setProducts] = useState(null);
  const [cat, setCat] = useState("all");

  useEffect(() => {
    http.get("/products").then((r) => setProducts(r.data)).catch(() => setProducts([]));
  }, []);

  const shown = (products || []).filter((p) => cat === "all" || p.category === cat);

  return (
    <section id="phones" className="py-20 md:py-28 bg-slate-50" data-testid="phones-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-brand-600">Shop</p>
            <h2 className="font-display mt-3 text-3xl sm:text-4xl font-black tracking-tight text-ink">Phones for Sale</h2>
            <p className="mt-3 text-slate-600 max-w-xl">New and A+ graded used phones, tablets and accessories in the shop now. See something you like? Message us on WhatsApp to check it's available.</p>
          </div>
          <div className="flex gap-2 overflow-x-auto pb-1 -mx-4 px-4 md:mx-0 md:px-0" role="tablist" data-testid="product-filters">
            {CATEGORIES.map((c) => (
              <button key={c.value} onClick={() => setCat(c.value)} className={`shrink-0 rounded-full px-5 py-2.5 text-sm font-bold transition-colors ${cat === c.value ? "bg-ink text-white" : "bg-white text-slate-700 border border-slate-200 hover:border-brand-600 hover:text-brand-600"}`} data-testid={`filter-${c.value}`}>
                {c.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="product-grid">
          {products === null && [0, 1, 2, 3].map((i) => <Skeleton key={i} className="h-[440px] rounded-2xl" />)}
          {shown.map((p) => <ProductCard key={p._id} product={p} />)}
        </div>

        {products !== null && shown.length === 0 && (
          <p className="mt-10 text-slate-600" data-testid="products-empty">Nothing listed here right now — <a className="font-bold text-brand-600 underline" href={waLink("Hi FONZ FIX4U, what phones do you have in stock?")} target="_blank" rel="noopener noreferrer">ask us what's in stock</a>.</p>
        )}

        <div className="mt-12 rounded-2xl bg-white border border-slate-200 p-6 md:p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="font-display text-lg md:text-xl font-bold text-ink">Looking for a model you don't see? We can help you find it.</p>
          <a href={waLink("Hi FONZ FIX4U, I'm looking for a phone. Can you help?")} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-brand-600 px-6 py-3 font-bold text-white hover:bg-brand-700 transition-colors" data-testid="phones-request-model-btn">Ask on WhatsApp</a>
        </div>
      </div>
    </section>
  );
};
